import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FitClosestTableDirective } from '../../directives';

@Component({
	// Must be an attribute based selector to prevent <table> layout break
	selector: '[table-row-empty]',
	templateUrl: './table-row-empty.component.html',
	imports: [TranslateModule, FitClosestTableDirective]
})
export class TableRowEmptyComponent {
	@Input() message = "DataList.NoResult";
}
